import { CSSProperties } from "react";

const alignCenter: CSSProperties = {
  alignItems: "center",
};

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "80%",
    margin: "0 auto",
  },
  titleArea1: {
    justifyContent: "flex-start",
  },
  title: {
    fontSize: 30,
  },
  titleArea2: {
    justifyContent: "flex-end",
    marginBottom: 2,
    ...alignCenter,
  },
  searchbox: {
    marginTop: "2rem",
  },
  tableHead: {
    backgroundColor: "#ddd",
  },
  dashboardViewBottanArea: {
    justifyContent: "flex-end",
    marginTop: "2rem",
    ...alignCenter,
  },
};
